import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.ADD = (state, payload) => {
  state.row = payload
}

mutations.CATS = (state, payload) => {
  state.categories = payload
}

const state = {
  rows: [],
  categories: [],
  row: null,
  condition: {}
}

const actions = {
  init: ({ commit }) => {
    const ctx = {
      data: {
        init: { api: 'M0501MailerService.init' }
      }
    }
    return client.postData(ctx)
      .then((data) => {
        const output = data.init.output
        if (output.rows.length === 0) {
          SysUtils.showInfo('No record found')
        }
        commit('FIND_ALL', output.rows)
        commit('CATS', output.categories)
      })
  },
  doAdd: ({ commit, state }) => {
    console.debug('called M0501Mailer add')
    commit('ADD', { send_to: 'EXISTING', files: {}, categories: state.categories.map(c => c.value) })
  },
  doSave: ({ commit }, row) => {
    console.debug('called M0501Mailer sendMail')
    return client.postData({ data: { save: { api: 'M0501MailerService.sendMail', input: row } } })
      .then((data) => {
        const output = data.save.output
        if (output.error) {
          return false
        } else {
          commit('EDIT', { files: {} })
          commit('FIND_ALL', output.init.rows)
          commit('CATS', output.init.categories)
          if (output.msg) {
            SysUtils.showInfo(output.msg)
          }
          return true
        }
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
